import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  FormControl,
  Box,
} from "@chakra-ui/react";
import Button from "components/Button/Button";
// import Input from "components/Input/Input";
import Select from "components/Select/Select";

const DownloadTradeHistory = ({ isOpen, onClose, isLoading, onDownload }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent
        bg="linear-gradient(0deg, #F8F9FD, #F8F9FD)"
        overflow="hidden"
        borderRadius="16px"
      >
        <ModalHeader p="20px 40px" bg="white" fontSize="md">
          Download
        </ModalHeader>
        <ModalCloseButton
          size="md"
          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
          top="14px"
          right="20px"
        />
        <ModalBody p="24px 40px">
          <FormControl>
            <Box
              as="label"
              d="inline-block"
              fontSize="md"
              fontWeight="500"
              mb="10px"
            >
              Status
            </Box>
            <Select>
              <option>All trades</option>
              <option>Completed</option>
              <option>Pending</option>
              <option>Cancelled</option>
            </Select>
          </FormControl>

          <FormControl mt="24px">
            <Box
              as="label"
              d="inline-block"
              fontSize="md"
              fontWeight="500"
              mb="10px"
            >
              Time
            </Box>
            <Select>
              <option>Last 24hrs</option>
              <option>Yesterday</option>
              <option>Last week</option>
              <option>Two week</option>
              <option>This month</option>
            </Select>
          </FormControl>
        </ModalBody>

        <ModalFooter justifyContent="center" pb="30px" gridGap="14px">
          <Button
            disabled={isLoading}
            isLoading={isLoading}
            minW="120px"
            onClick={onDownload}
          >
            Download
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DownloadTradeHistory;
